import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { Link } from "react-router-dom";

export default function VertProjectCard({
    title="-", 
    emoji="banana", 
    desc = "-",
    first=false,
    linkTo="/ProjectDetails",
    gradientStart="#FADB53", 
    gradientEnd="#F0BE15", 
    state,
    thumbnail=require("../../assets/3d/banana.png"),
    thumbnailAlt="banana"
}) {

    return (
        <Link 
            className={
                `
                    border-[#8A8A8A]/[.30]
                    border-r
                    ${
                        first?"border-l":""
                    }
                    h-full 
                    w-1/5 
                    overflow-hidden
                    relative
                    group
                `
            } 
            to={linkTo} 
            state={state}
        >



            <div
                className={`
                    absolute
                    w-full
                    h-full
                    left-[-100%]


                    group-hover:left-0
                    transition-all
                    duration-500
                    ease-in-out
                `}
                style={{
                    backgroundImage: `linear-gradient(to bottom, ${gradientStart}, ${gradientEnd})`,
                }}
            />

            <div
                className={`
                    absolute
                    h-4/5
                    w-[120%]
                    left-[-150%]
                    top-1/2
                    -translate-y-1/2


                    group-hover:left-[20%]
                    transition-all
                    duration-700
                    ease-in-out
                `}
            >
                <img 
                    src={thumbnail}
                    alt={thumbnailAlt}
                    className="
                        object-contain
                        object-center
                        h-full
                        w-full
                    "
                />
            </div>

            <div
                className={
                    `
                        flex
                        flex-col
                        justify-center
                        items-end
                        h-full
                        w-full
                        px-5
                        absolute
                        right-0


                        group-hover:right-[-100%]
                        transition-all
                        duration-700
                        ease-in-out

                    `
                }
            >
                <div>
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name={emoji} width={44}/>
                    </EmojiProvider>

                </div>
                <h2
                    className="
                        text-home-text-light
                        dark:text-home-text-dark
                        text-4xl
                        text-end
                        tracking-widest
                        font-medium
                        my-2.5
                    "
                >
                    &nbsp;{title}
                </h2>
                <span
                    className="
                        text-base
                        text-home-text-grey
                        block
                        font-medium
                        tracking-wider
                    "
                >
                    {
                        desc
                    }
                </span>
            </div>


        </Link>


    );
}